// Shared form/validation copy so the same message isn't hard-coded per screen.
export const SELECT_ANSWER_ERROR = "Please select an answer to continue."
